window.addEventListener('alpine:init', () => {
  var { getDefaultAlpineMorphLifecycleHooks } = Alpine.store('utilities');

  var defaultAlpineMorphLifecycleHooks = getDefaultAlpineMorphLifecycleHooks();

  function resourceListing(data = {}) {
    return {
      ...data,

      isLoadingResourceListing: false,

      page: +(new URLSearchParams(location.search).get('page') || '1'),

      init() {
        this.onEventStart = this.onEventStart.bind(this);
        this.onEventEnd = this.onEventEnd.bind(this);
        this.onEventSuccess = this.onEventSuccess.bind(this);

        window.addEventListener('facetsformsubmitstart', this.onEventStart);
        window.addEventListener('facetsformsubmitend', this.onEventEnd);
        window.addEventListener('facetsformsubmitsuccess', this.onEventSuccess);

        window.addEventListener('resourcelistinglinkclickstart', this.onEventStart);
        window.addEventListener('resourcelistinglinkclickend', this.onEventEnd);
        window.addEventListener('resourcelistinglinkclicksuccess', this.onEventSuccess);
      },

      destroy() {
        window.removeEventListener('facetsformsubmitstart', this.onEventStart);
        window.removeEventListener('facetsformsubmitend', this.onEventEnd);
        window.removeEventListener('facetsformsubmitsuccess', this.onEventSuccess);

        window.removeEventListener('resourcelistinglinkclickstart', this.onEventStart);
        window.removeEventListener('resourcelistinglinkclickend', this.onEventEnd);
        window.removeEventListener('resourcelistinglinkclicksuccess', this.onEventSuccess);
      },

      onEventStart() {
        this.isLoadingResourceListing = true;
      },

      onEventEnd() {
        this.isLoadingResourceListing = false;
      },

      onEventSuccess(event) {
        this.render(event.detail.url, event.detail.sectionHtml);

        if (event.detail.scrollToEl) {
          var scrollToEl = document.querySelector(event.detail.scrollToEl);

          if (scrollToEl) {
            scrollToEl.scrollIntoView();
          }
        }
      },

      render(url, sectionHtml) {
        this.updateUrl(url);

        Alpine.morph(this.$root, sectionHtml, defaultAlpineMorphLifecycleHooks);
      },

      updateUrl(url) {
        window.history.replaceState(null, null, url);
      }
    };
  };

  Alpine.data('resourceListing', resourceListing);
});
